export default __webpack_public_path__ + "static/creating-cfae881f7d727634424161a1ee8a9db3.svg";